import i18n from '@/helpers/i18n';

export default [
  {
    _name: 'CSidebarNav',
    _children: [ 
      {
        _name: 'CSidebarNavTitle',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('fleet/members'),
        to: '/frota&membros/lista',
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('heros'),
        to: '/capa/lista',
        icon: 'cil-library',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('keyValues'),
        to: '/informacoes/lista',
        icon: 'cil-library',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('services'),
        to: '/serviços/lista',
        icon: 'cil-library',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('staticInfos'),
        to: '/paginas/lista',
        icon: 'cil-File',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('settings'),
        to: '/definicoes',
        icon: 'cil-settings'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('profile'),
        to: '/perfil',
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('logout'),
        to: '/logout',
        icon: 'cil-power-standby'
      },
      {
        _name: 'CSidebarNavTitle',
      }
    ]
  }
]